module.exports = __webpack_public_path__ + "img/point_pause.f928ca84.svg";